// Shared utility for Google Translate language/direction state
// Kept separate to avoid circular imports between LanguageContext and GoogleTranslateSwitcher

const TRANSLATE_LANG_KEY = "google-translate-lang";

export const TRANSLATE_LANGUAGES_CONFIG = [
  { code: "", dir: "rtl" as const },
  { code: "en", dir: "ltr" as const },
  { code: "ru", dir: "ltr" as const },
  { code: "ar", dir: "rtl" as const },
];

export function getTranslateDir(): "rtl" | "ltr" {
  const saved = getTranslateLang();
  const lang = TRANSLATE_LANGUAGES_CONFIG.find((l) => l.code === saved);
  return lang?.dir || "rtl";
}

export function getTranslateLang(): string {
  if (typeof window === "undefined") return "";
  return localStorage.getItem(TRANSLATE_LANG_KEY) || "";
}

export function setTranslateLang(langCode: string) {
  localStorage.setItem(TRANSLATE_LANG_KEY, langCode);
}
